<div>
  <iframe [src]="safeUrl" width="600" height="400" (error)="onError($event)"></iframe>
</div>
